import { Tag, Tooltip } from 'antd';
import React from 'react';

import style from './style';

const TagTile = props => {
  const { tag, tagClose } = props;
  const { children, value, input } = tag;
  const childrenStr = children.toString();
  const isLongTag = childrenStr.length > 20;

  const tagNode = (
    <Tag
      css={style.filterTag}
      key={`${input}--${value}`}
      closable
      onClose={e => tagClose(e, value, input)}
    >
      {isLongTag ? `${childrenStr.slice(0, 20)}...` : childrenStr}
    </Tag>
  );

  return isLongTag ? (
    <Tooltip title={childrenStr} key={`${input}--${value}`}>
      {tagNode}
    </Tooltip>
  ) : (
    tagNode
  );
};

TagTile.propTypes = {};

export default TagTile;
